import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { MpsPlanNotCompletedDialogContent } from './MpsPlanNotCompletedDialogContent'

interface IProps {
  isShowDialog: boolean
  message: string
  onClose: () => void
}

export const MpsPlanNotCompletedDialog = ({ isShowDialog, message, onClose }: IProps) => {
  const contentProps = useMemo(() => {
    return { message, onClose }
  }, [message, onClose])

  return (
    <ModalDialog
      size={'xs'}
      show={isShowDialog}
      content={MpsPlanNotCompletedDialogContent}
      contentProps={contentProps}
      onClose={onClose}
    />
  )
}
